import { Component } from 'vue-property-decorator'
import { InspectionBase } from '@/components/forms/inspection/InspectionBase'

@Component
export class ScheduledInspectionView extends InspectionBase {

}
